'use client';
import { useEffect, useState } from 'react';
import { TagsInput as BaseTagsInput } from 'react-tag-input-component';

export const TagsInput = <K,>({
  placeHolder,
  handleChangeValue,
  name,
  values = '',
}: {
  handleChangeValue: (key: K, value: any) => void;
  placeHolder: string;
  values?: string;
  name: K;
}) => {
  const [selected, setSelected] = useState<string[]>(
    values ? (Array.isArray(values) ? values : values.split('; ')) : []
  );

  useEffect(() => {
    handleChangeValue(name, selected.join('; '));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <BaseTagsInput
      value={selected}
      onChange={setSelected}
      name={name as string}
      placeHolder={placeHolder}
    />
  );
};
